module.exports = __webpack_public_path__ + "img/imiwin-support.9f36b667.png";